import { useEffect, useState } from "react";
import { useSocket } from "context/SocketContext";
import { initSocketConnection, subscribeToSocket } from "../../utils/socket";

export default function useLiveDrivers(locationId) {
  const [driversData, setDriversData] = useState([]);
  const { socket, isConnected, drivers } = useSocket();

  useEffect(() => {
    if (!socket || !isConnected || !locationId) return;

    const unsubLive = subscribeToSocket("sendDriverLocationUpdate", (update) => {
        

        if (update && typeof update === "object" && update.driverId) {
          setDriversData((prev) => {
            const current = Array.isArray(prev) ? prev : [];
            const filtered = current.filter((d) => d.driverId !== update.driverId);
            return [...filtered, update];
          });
        }
    });

    return () => {
      unsubLive();
    };
  }, [socket, isConnected, locationId]);


  useEffect(() => {

    setDriversData(drivers);

  }, [drivers])

  return driversData;
}